import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AuthLayout from "../customComponent/AuthLayout";
import { useDispatch } from "react-redux";
import { resetAdminPassword } from "../../redux/action/Auth/ForgetPasswordAction";
import { LOGIN } from "../utils/RouteConstant";
import { useLocation, useNavigate } from "react-router";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { TextField, InputAdornment, IconButton, Modal, Box } from "@mui/material";
import SuccessBackground from "../../asesst/SuccessBackground.svg";
import Tick from "../../asesst/tick.svg";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [resetToken, setResetToken] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    if (token) {
      setResetToken(token);
    } else {
      navigate("/forgot-password");
      // navigate("/reset-password");
    }
  }, [location, navigate]);
  const validationSchema = Yup.object().shape({
    new_password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(
        /[!@#$%^&*]/,
        "Password must contain at least one special character"
      )
      .required("New password is required"),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const initialValues = {
    new_password: "",
    confirm_password: "",
  };

  const handleOpeSuccessModal = () => {
    setOpenSuccessModal(true);
  };

  const  handleClose = ()=>{
       navigate(LOGIN);
  }

  const handleSubmit = async (values) => {
    try {
      await resetAdminPassword(values.new_password, resetToken, dispatch);
      console.log("Password reset successfully");
      handleOpeSuccessModal()
    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };

  const changePassword = (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values }) => (
          <Form className="space-y-4 md:space-y-6">
            <div>
              <Field
                name="new_password"
                as={TextField}
                fullWidth
                label="New Password"
                // required
                type={showPassword ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <ErrorMessage
                name="new_password"
                component="div"
                className="text-red-500"
              />
            </div>
            <div className="password-indicators mt-4 gap-4">
              <ul>
                <li
                  className={
                    values.new_password.length >= 8
                      ? "text-green-500 mb-2"
                      : "text-red-500 mb-2"
                  }
                >
                  <span className="mr-2 align-middle">
                    {values.new_password.length >= 8 ? "✔️" : "❌"}
                  </span>{" "}
                  At least 8 characters
                </li>
                <li
                  className={
                    /[a-z]/.test(values.new_password)
                      ? "text-green-500 mb-2"
                      : "text-red-500 mb-2"
                  }
                >
                  <span className="mr-2 align-middle">
                    {/[a-z]/.test(values.new_password) ? "✔️" : "❌"}
                  </span>{" "}
                  At least one lowercase letter
                </li>
                <li
                  className={
                    /[A-Z]/.test(values.new_password)
                      ? "text-green-500 mb-2"
                      : "text-red-500 mb-2"
                  }
                >
                  <span className="mr-2 align-middle">
                    {/[A-Z]/.test(values.new_password) ? "✔️" : "❌"}
                  </span>{" "}
                  At least one uppercase letter
                </li>
                <li
                  className={
                    /[0-9]/.test(values.new_password)
                      ? "text-green-500 mb-2"
                      : "text-red-500 mb-2"
                  }
                >
                  <span className="mr-2 align-middle">
                    {/[0-9]/.test(values.new_password) ? "✔️" : "❌"}
                  </span>{" "}
                  At least one number
                </li>
                <li
                  className={
                    /[!@#$%^&*]/.test(values.new_password)
                      ? "text-green-500 mb-2"
                      : "text-red-500 mb-2"
                  }
                >
                  <span className="mr-2 align-middle">
                    {/[!@#$%^&*]/.test(values.new_password) ? "✔️" : "❌"}
                  </span>{" "}
                  At least one special character
                </li>
              </ul>
            </div>
            <div className="mt-4">
              <Field
                name="confirm_password"
                label="Confirm Password"
                as={TextField}
                fullWidth
                // required
                type={showConfirmPassword ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        edge="end"
                      >
                        {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <ErrorMessage
                name="confirm_password"
                component="div"
                className="text-red-500"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-blue-900 text-white py-2 px-4 rounded-md hover:bg-blue-800 transition duration-300"
            >
              Reset Password
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );

  return (
    <>
      <AuthLayout
        title="Reset Password?"
        description="Don't worry, happens to all of us. Enter your new password below."
        form={changePassword}
      />
      <Modal open={openSuccessModal} className="justify-center items-center ">
        <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
          <div className="text-center inline-flex mt-8">
            <div
              className="w-[72px] h-[72px] flex items-center justify-center"
              style={{ backgroundImage: `url(${SuccessBackground}` }}
            >
              <img src={Tick} alt="Success" className="w-7 h-7" />
            </div>
          </div>
          <p className="text-3xl text-[#0B0B0B] font-semibold mt-4 mb-4">
            Success
          </p>
          <span className="text-[#6D6D6D]">
            Your password has been successfully reset. You can now log in with
            your new password.
          </span>
          <div className="mt-6 flex justify-center gap-4">
            <button
              onClick={handleClose}
              className="border border-inherit px-4 py-2 rounded-lg"
            >
              Close
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ChangePassword;
